import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { Box, Card, CardActions, CardMedia, Typography } from "@mui/material";
import * as CONST from "../Constants";

const propTypes = {
  message: PropTypes.string.isRequired,
  media: PropTypes.object.isRequired,
};
CardComponent.prototype = propTypes;

export default function CardComponent(props) {
  const history = useHistory();
  return (
    <Box pl={3} pr={3} pt={3}>
      <Card className="patient-feed-card">
        <CardMedia
          p={2}
          pb={4}
          sx={{
            overflow: 'auto !important',
            bgcolor: "#42b3f4",
            color: "#fff",
          }}
        >
          <Box sx={{ display: "inline-flex", padding: "16px  16px 32px" }} alignItems="flex-start">
            {props.media}
            <Typography variant="h3" component="div" pl={2} color="#ffff" pt={2}>
              {props.message}
            </Typography>
          </Box>
        </CardMedia>
        <CardActions>
          <button className="color" onClick={(e) => history.push("/patient_portal/dashboard")}>
            {CONST.GO_TO_DASHBOARD}
          </button>
        </CardActions>
      </Card>
    </Box>
  );
}
